import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import SignIn from "modules/okta/signin";
import { useOktaAuth } from "@okta/okta-react";
import AppFooter from "@APP_FOOTER";
import AppHeader from "@APP_HEADER";
import commonUtilities from "utilities/common";
import { CONSTANTS } from "utilities/constants";

const PrivateRoute = ({ profileLoaded, children }) => {

    if(!profileLoaded) return null;

    const params = useParams() || {};
    const { authState } = useOktaAuth();
    const isLoggedIn = useMemo(() => authState?.isAuthenticated || false, [authState]);
    const hasAccess = !commonUtilities.isCustomerUser() || (commonUtilities.isCustomerUser() && process.env.REACT_APP_BRAND === CONSTANTS.BRAND_DEFAULT);
    
    if(!isLoggedIn) return <SignIn />;
    if (!hasAccess) return null;;
    return (
        <div className="base-container"> 
            <AppHeader />
            <div className="main">
                {React.cloneElement(children, { params })}
            </div>
            <AppFooter />
        </div>
    );
};

export default PrivateRoute;